module.exports = __webpack_public_path__ + "img/product_49.377ed83.webp";